import { translate } from "app/filters/i18nFilter";
import { StyledAdNetworksDefaultCell } from "../../../components/tooltips/shared/styles";
import type TooltipTableColumn from "../../../models/view/signals-tooltip/TooltipTableColumn";
import createSignalsTooltipTableColumn from "../base/toolipBaseColumnFactory";
import {
    TOOLTIP_COLUMN_AD_NETWORK_NAME,
    TOOLTIP_COLUMN_AD_NETWORK_SHARE,
} from "app/pages/sales-intelligence/sub-modules/signals/services/table-columns/ad-network/const";
import AdNetworkSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/ad-network/AdNetworkSignalSubType";
import AdNetworkProgressBarContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/AdNetworkProgressBarContainer/AdNetworkProgressBarContainer";

type FactoryDeps = {
    parentColumnName: string;
    signalSubType: AdNetworkSignalSubType;
};

const ADDED_AD_NETWORK_NAME_WIDTH = 220;
const REMOVED_AD_NETWORK_NAME_WIDTH = 300;
const AD_NETWORK_SHARE_WIDTH = 300;

export default function createAdNetworksTooltipColumnsResolver({ parentColumnName, signalSubType }: FactoryDeps) {
    const COLUMN_DISPLAY_NAME_KEY = "si.signals.table-columns.tooltip.table.column";
    const isRemovedAdNetworks = signalSubType === AdNetworkSignalSubType.RemovedAdNetworks;

    return {
        getTableColumns(): TooltipTableColumn[] {
            const commonColumns = [
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_AD_NETWORK_NAME,
                    displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.adNetworkName`),
                    maxWidth: isRemovedAdNetworks ? REMOVED_AD_NETWORK_NAME_WIDTH : ADDED_AD_NETWORK_NAME_WIDTH,
                    cellComponent: StyledAdNetworksDefaultCell,
                }),
            ];

            if (isRemovedAdNetworks) {
                return commonColumns;
            }

            return [
                ...commonColumns,
                createSignalsTooltipTableColumn({
                    field: TOOLTIP_COLUMN_AD_NETWORK_SHARE,
                    displayName: translate(`${COLUMN_DISPLAY_NAME_KEY}.${parentColumnName}-trafficShare`),
                    maxWidth: AD_NETWORK_SHARE_WIDTH,
                    cellComponent: AdNetworkProgressBarContainer,
                }),
            ];
        },
    };
}
